<template>
  <div>
    <pc-header :isTransparent.sync="isTransparent"></pc-header>

    <div class="about">
      <img alt src="~@/assets/pc/sunlight.jpg" />
      <div class="text sketch  padding-top">
        东阳光是一个充满希望、活力、正在铸就百年基业的高科技大型股份制企业，现有员工2万余人；
        主要从事生物医药、电子材料和健康养生三大产业，现有广东东莞、广东韶关、湖北宜昌、西藏林芝、贵州遵义、内蒙古乌兰察布六大基地。
      </div>
      <div class="text sketch">
        公司始终以“一支能征善战的军队、一所培养人才的学校、一个和谐友爱的家庭”作为组织建设的目标；在建设
        物质文明的同时，努力塑造东阳光人“忠诚、规矩、规划、创新”的品格，实现我们提出的“中有所为、老有所养、小有所依”美好愿景，大力发展核心技术研发型实体经济。
      </div>
      <div class="text title  padding-top-xs">
        基本概述
      </div>
      <div class="text sketch">
        东阳光冬虫夏草项目,历经十年科研攻关，突破了多重技术难题，
        率先实现了冬虫夏草繁育技术的大规模产业化，有效解决了名贵中药材冬虫夏草野生资源稀缺和无法规模化繁育的问题，将对生态环境改善、产业可持续发展及产业转型升级产生积极影响。
      </div>
      <div class="text title  padding-top-xs">
        产品特点
      </div>
      <div class="text sketch padding-bottom">
        东阳光集团在尊重自然的基础上，遵循冬虫夏草生活习性，运用智能生态科技和大数据统计分析技术，模拟冬虫夏草生长生育所需土壤、光照、紫外线、湿度、温度、
        气压及食物等相关因素变化规律，高度模仿并创造出适宜冬虫夏草生长的生态环境条件，实现了冬虫夏草生态繁育产业化。               
      </div>
      <div class="text">地址：东莞市长安镇上沙第五工业区东阳光科技园</div>
      <div class="text">邮编：523871</div>
      <div class="text">电话：4000-552-888</div>
    </div>
  </div>
</template>

<script>
import pcHeader from "@/components/pcHeader"

export default {
  metaInfo: {
    title: "关于我们|东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  components: {
    "pc-header": pcHeader
  },
  data () {
    return {
      isTransparent: false // 是否透明
    }
  }
}
</script>

<style scoped lang="stylus">
img {
  width: 100%;
}

body {
  overflow-y: hidden;
}

.about {
  margin-top: -80px;

  .sketch {
    text-indent: 2em;
    font-size: 20px;
    font-weight: bold;
  }

  .padding-top {
    padding-top: 58px;
  }

  .padding-top-xs {
    padding-top: 28px;
  }

  .padding-bottom {
    padding-bottom: 75px;
  }

  .title {
    color: rgba(236, 172, 27, 1);
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
  }

  .text {
    margin: 0 auto;
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// pcAbout.vue